export const createSlug = (title = "", artist = "") => {
    const slug = `${title}-by-${artist}`;

    return slug
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/--+/g, '-');
};